import React, { useState, useEffect } from "react";
import { getOrDeleteRequest, getSession } from "../../../utils/utils";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import MainThemeLayout from "../../../layout/MainThemeLayout";
import DataTableComponent from "../../../components/DataTableComponent";

const Employees = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);

    const getEmployees = async (page = 1) => {
        setLoading(true);
        let response = await getOrDeleteRequest(
            `employees/index-by-company/${getSession().company.id}?page=${page}`,
            'GET',
        );
        // console.log(response);
        if (response.type === 'success') {
            setData(response.data);
        } else {
            setData([]);
        }
        setLoading(false);
    };

    const columns = [
        {
            name: 'Nombres',
            selector: (row) => row.user?.personal_data?.names
        },
        {
            name: 'Apellidos',
            selector: (row) => row.user?.personal_data?.lastnames
        },
        {
            name: 'Cargo',
            selector: (row) => row.charge,
        },
        {
            name: 'Credencial',
            selector: (row) => row.credential,
        },
        {
            name: 'Estado',
            width: '200px',
            selector: (row) => row.status === 1 ? "Activo" : "Inactivo"
        },
    ];

    useEffect(() => {
        getEmployees();
    }, []);

    return (
        <MainThemeLayout>
            <div className="px-8 py-6">
                <div className="mb-4">

                    <h1 className="text-xl font-semibold text-stone-800 dark:text-white mb-2">
                        Empleados
                    </h1>
                    <p className="text-sm text-stone-500 dark:text-white">
                        Listado de empleados registrados en la plataforma.
                    </p>
                </div>
                <div>
                    <DataTableComponent
                        nameTable={'Empleados'}
                        data={data}
                        columns={columns}
                        setLoading={setLoading}
                        loading={loading}
                        // toView="/VerPerfilOrg/"
                        toEdit="/EditarEmpleado/"
                        // url de la ruta
                        toDisable="employees/disable/"
                        toEnable="employees/enable/"
                        toDelete="employees/destroy/"
                        reload={getEmployees}
                        button={
                            <Link to={"/AgregarEmpleado"} className="bg-turquesa hover:opacity-90 rounded-lg px-4 py-2 text-sm text-white cursor-pointer">
                                Agregar
                            </Link>
                        }
                    />
                </div>
            </div>
        </MainThemeLayout>
    );
};

export default Employees;
